import { render, staticRenderFns } from "./clientAccountStatementConfiguration.vue?vue&type=template&id=45f9e6f8&"
import script from "./clientAccountStatementConfiguration.vue?vue&type=script&lang=js&"
export * from "./clientAccountStatementConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports